<template>
  <LayoutMinimal>
    <div id="sing-up">
      <section class="main">
        <div class="container">
          <div class="form loadable failable" :class="{loading: newUserData.loading, failed: newUserData.error}">
            <h1 class="title">
                {{$t('register.title')}}
            </h1>
            <template v-if="newUserData.loading || newUserData.error || newUserData.data">
                <RegisterForm
                        :autologin="true"
                        @successfullRegister="successfullRegisterHandler"
                        @failedRegister="failedRegisterHandler"
                />
            </template>
            
            <template v-if="!newUserData.loading && !newUserData.error && !newUserData.data">
                <p>
                    {{$t('finish_registration.invalid_token.error')}}
                </p>
                <button type="button" class="btn login" @click.prevent="goToLogin">
                    {{$t('finish_registration.invalid_token.go_to_login')}}
                </button>
            </template>
            
            <div class="loader-wrapper">
              <Spinner/>
            </div>
            
            <div class="failed-wrapper">
                <p>{{$t('error')}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <template slot="after">
      <Footer/>
    </template>
  </LayoutMinimal>
</template>

<script>
import Spinner from "../components/Spinner";
import Footer from "../components/Footer";
import LayoutMinimal from "../layouts/LayoutMinimal";
import RegisterForm from "../components/RegisterForm";
import PaymentStatus from "../components/PaymentStatus";

export default {
  components: {
      PaymentStatus,
      RegisterForm,
      LayoutMinimal,
      Spinner,
      Footer
  },
  data(){
    return {
        token: '',
        newUserData: {
            data: {
                email: null,
                finish_token: null,
            },
            loading: false,
            error: false,
        },
    }
  },
  methods:{
      successfullRegisterHandler(){
          if(this.$auth.user().membership_active){
              this.$router.replace({name: 'home'});
          }else{
              this.$router.replace({name: 'dashboard'});
          }
      },
      failedRegisterHandler(resp){
        //this.$router.replace({name: 'login'});
      },
      goToLogin(){
          this.$router.push({name: 'login'});
      }
  },
    
    computed: {
    },
    
  watch: {
  },
  mounted(){
      this.token = this.$route.query.token;
  },
    beforeDestroy() {
    }
}
</script>

<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';

#sing-up {
  background-color: $pallete_dark_color;
  display: flex;
  color: $pallete_clear_text_color;
  flex-direction: column;
  justify-content: center;
  max-width: 750px;

  .highlight-payment-box{
      margin: 1em;
  }

  .btn.login{
      @extend %fresh-btn;
      display: block;
      width: 100%;
      padding: 1em;
  }

  section.main {
    justify-content: space-around;
    position: relative;
    margin: 0;

    .container {
      display: flex;
      margin: 0 auto;
      padding: 1.5em;
      background-color: #e6e6e6;
      border-radius: 10px;
      background: linear-gradient(to bottom, #e6e6e6 0, #ccc 100%);
      margin-left: 1em;
      margin-right: 1em;

      @media(max-width: 450px) {
        border-radius: 0;
        margin-left: 0;
        margin-right: 0;
        padding: .5em;
        width: 100vw;
      }

      .form {
        display: block;
        padding: 1em;
        background-color: #000000;
        border-radius: 5px;
        width: 100%;

        .title {
          text-align: center;
          width: 100%;
          text-transform: uppercase;
          letter-spacing: 0;
          margin: 0 0 .5em 0;
        }

        @media(max-width: 500px) {
          min-width: auto;
        }
      }
    }
  }

  .failed-wrapper{
      text-align: center;
      font-weight: bolder;
      padding-top: 1em;
  }
}
</style>
